/* eslint-disable */
import React from 'react';
import { Box } from '../components/Layout';
import { Footer } from '../components/Footer';

const NotFound = () => (
  <Box>
    <Box
      width={[1, 1, 1 / 2]}
      m={['3.5rem 0 0 0', '3.5rem 0 0 0', '3.5rem auto 0 auto']}
      px={[3, 3, 0]}
    >
      <h1>Site not found</h1>
      <p>
        Sorry, this might be a broken link. Please report to webmaster@chi.camp.
      </p>
    </Box>
    <Footer/> 
  </Box>
);

export default NotFound;



// WEBPACK FOOTER //
// ./src/pages/404.js